import styled from 'styled-components';

export const Container = styled.div`
    padding: 20px;
  .pagination {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #D3D3D3;
  padding-bottom: 20px;
  gap: 20px;

  .title {
    h1 {
        font-family: 'Inter';
        font-weight: 500;
        font-size: 28px;
        color: #333;
        margin-bottom: 2px;
    }
    p {
        font-family: 'Inter';
        font-weight: 400;
        font-size: 16px;
        color: #566583;
    }
  }

  .actions {
    button {
      display: flex;
      align-items: center;
      /* text-overflow: ellipsis; */
      white-space: nowrap;

      gap: 4px;
      box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
      box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
      padding: 6px 14px;
      /* border: 1px solid #D3D3D3; */
      border-radius: 6px;
      font-family: 'Roboto';
      font-weight: 500;
      font-size: 14px;
      color: #333;
      cursor: pointer;
      background: #fff;

      &:hover {
        opacity: 0.8;
      }
    }
  }
`;
export const Filtros = styled.div`
  margin-top: 40px;
  background: #fff;
  padding: 15px 10px 15px 10px;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
  border-radius: 10px;

  .input-wrapper {
      display: flex;
      align-items: center;
      gap: 10px;
      label {
        font-family: 'Inter';
        font-size: 14px;
        font-weight: 400;
      }
    }

  .MuiTextField-root {
        .MuiOutlinedInput-root {
          height: 40px;
        }
      }

`;

export const ContactContainer = styled.div`
  background: #fff;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
  border-radius: 10px;
  margin-top: 40px;
  margin-bottom: 40px;
  overflow: auto;
`;

export const ContactTable = styled.table`
  padding: 10px;
  table-layout: fixed;
  /* border: 1px solid #333; */
  border-collapse: collapse;
  width: 100%;
  min-width: 800px;
  thead {
    padding: 0 10px;
    border-bottom: 1px solid #D3D3D3;
    /* border-top: 1px solid #D3D3D3; */

    th {
      color: #a8a39d;
      font-weight: 400;
      font-family: 'Poppins';
      font-size: 14px;
      /* padding: 10px 0px; */
    }

    /* th:first-child {
      width: 50px;
      padding: 0 10px;
    } */

    th:last-child {
      width: 10%;
    }
    
  }

  tbody {

    tr:not(tr:last-child) {
      border-bottom: 1px solid #D3D3D3;
    }

    tr > td {
      color: #333;
      font-family: 'Inter';
      font-weight: 400;
      font-size: 14px;
    }

    /* td:first-child {
      width: 50px;
      padding: 0 10px;
    } */
    tr {
      cursor: pointer;

      &:hover {
        background: rgba(0, 157, 221, 0.1);
      }
    }
  }

  td, th {
    padding: 15px 10px;
    text-align: left;
  }

  .order {
    display: flex;
    align-items: center;
    gap: 3px;
    transform: rotate(0deg);
    transition: transform .2s ease-in;
    cursor: pointer;
  }

  .order.desc {
    svg {
      transform: rotate(180deg);
    }
  }

  .checkbox {
    width: 16px;
    height: 16px;
    cursor: pointer;
  }

  td.actions {
    width: 10%;
    color: #566583;
    display: flex;
    align-items: center;
    svg:first-child {
        margin-right: 10px;
    }
  }
`;
